export default __webpack_public_path__ + "static/flag-dk-bb4c4ea36cb0954e70f801e3077b663d.svg";